import { render } from "./BaseCountdown.vue?vue&type=template&id=dca3202e&scoped=true"
import script from "./BaseCountdown.vue?vue&type=script&lang=js"
export * from "./BaseCountdown.vue?vue&type=script&lang=js"

import "./BaseCountdown.vue?vue&type=style&index=0&id=dca3202e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dca3202e"

export default script